import { isEmpty, some } from 'lodash/fp';

import { SessionStorageKeys } from '../../types';
import browserUtils from '../../../../utils/browser';

const hasSessionDataToRehydrate = (sessionStorageKeys: SessionStorageKeys | undefined): boolean => {
  const { sessionStorage } = browserUtils.getWindow();

  return some(({ key }) => {
    const storageValue = sessionStorage.getItem(key);
    return !isEmpty(storageValue);
  }, sessionStorageKeys);
};

export default hasSessionDataToRehydrate;
